import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {faBoxOpen, faPallet, faCogs, faClock, faWeightHanging} from '@fortawesome/free-solid-svg-icons';
import {ShipmentInfo} from '../../../../models/shipment-info.model';
import {FormBuilder} from '@angular/forms';
import {FormService} from '../../../../services/form.service';
import {Dienst} from '../../../../models';

@Component({
  selector: 'lib-corrected-values',
  templateUrl: './corrected-values.component.html',
  styleUrls: ['./corrected-values.component.css']
})

export class CorrectedValuesComponent implements OnInit {

  // Icons
  public faBoxOpen = faBoxOpen;
  public faPallet = faPallet;
  public faCogs = faCogs;
  public faClock = faClock;
  public faWeightHanging = faWeightHanging;

  public showTimePicker: boolean = true;
  public setDeliveryTime: boolean = false;
  public isColPalValid: boolean = true;
  public isGewichtValid: boolean = true;
  public displayError: boolean = false;


  public colli: number = 0;
  public palette: number = 0;
  public totalColliAndPalette: number = 0;
  public emptyString: string = '';


  @Input() shipmentInfoDetails: ShipmentInfo;
  @Input() dienste: Dienst[];
  public selectedDropdownDienst: Dienst;

  public diensttypId: number;
  public selectedDienst: string;
  public timeToDisplay;
  public selbstabholer: boolean = false;

  public keepWeight: string = '';
  public keepColli: number;
  public keepPalette: number;

  @Output() submitCloseModalEvent = new EventEmitter<any>();

  constructor(private fb: FormBuilder, private cd: ChangeDetectorRef, private formService: FormService) {
    this.setTime();
  }

  setTime() {
    let now = new Date();
    let hours = ('0' + now.getHours()).slice(-2);
    let minutes = ('0' + now.getMinutes()).slice(-2);
    let str = hours + ':' + minutes;
    this.timeToDisplay = str;
  }

  activateAbholer(event: any) {
    this.selbstabholer = event.currentTarget.checked;
    this.formService.selbstabholer.next(this.selbstabholer);
  }

  ngOnInit(): void {
    this.totalColliAndPalette = this.shipmentInfoDetails.colli + this.shipmentInfoDetails.paletten;
    this.keepWeight = this.shipmentInfoDetails.gesamtgewicht;
    this.keepColli = this.shipmentInfoDetails.colli;
    this.keepPalette = this.shipmentInfoDetails.paletten;

    // Wenn der User keine Dienstkorrektur durchführt, dann wird der aktuelle Dienst übernommen
    this.shipmentInfoDetails.dienste.map((currentDienst) => {
      if (currentDienst.anzeigeKuerzel !== null) {
        this.dienste.forEach((allowedDienste) => {
          if (allowedDienste.code === currentDienst.code) {
            this.selectedDropdownDienst = currentDienst;
            this.getDienstData(this.selectedDropdownDienst);
          }
        });
      }
    });

    this.filterSaturdayFromCombobox();
    this.sortedDienste(this.dienste);
  }


  public filterSaturdayFromCombobox() :void {
    this.dienste.map((dienst: Dienst, index: number) => {
      if (dienst.code === 'SAMSTAG') {
        this.dienste.splice(index, 1);
      }
    })
  }

  checkTotalOfColliAndPalette(inputtype, value) {

    if (value.model === '' && inputtype === 'colli') {
      this.shipmentInfoDetails.colli = 0;
    }else if (value.model === '' && inputtype === 'palette'){
      this.shipmentInfoDetails.paletten = 0;
    }

    if (this.isCorrectedValuesNotNull()) {
      this.colli = +this.shipmentInfoDetails.colli;
      this.palette = +this.shipmentInfoDetails.paletten;
      const correctedColliAndPalette = this.colli + this.palette;

      this.totalColliAndPalette === correctedColliAndPalette ? this.isColPalValid = true : this.isColPalValid = false;
      this.cd.detectChanges();

    } else {
      this.isColPalValid = false;
      this.cd.detectChanges();
    }
  }

  isCorrectedValuesNotNull(): boolean {
    const colli = this.shipmentInfoDetails.colli;
    const palette = this.shipmentInfoDetails.paletten;

    const colliValidate = colli !== null && colli >= 0;
    const palValidate = palette !== null && palette >= 0;

    return colliValidate && palValidate;
  }

  onSubmit(isCorrectedValue: any): void {
    if (isCorrectedValue) {
      this.shipmentInfoDetails.datumUhrzeit = this.formatedDateString(new Date());

      const requestObject = {
        colli: this.shipmentInfoDetails.colli,
        palette: this.shipmentInfoDetails.paletten,
        gewicht: this.shipmentInfoDetails.gesamtgewicht,
        dienste: this.selectedDropdownDienst,
        diensttypid: this.selectedDropdownDienst.id,
        datumUhrzeit: this.shipmentInfoDetails.datumUhrzeit
      };

      this.formService.getSubmittedForm(requestObject);
    } else {
      this.shipmentInfoDetails.gesamtgewicht = this.keepWeight;
      this.shipmentInfoDetails.colli = this.keepColli;
      this.shipmentInfoDetails.paletten = this.keepPalette;
    }
    this.submitCloseModalEvent.emit(isCorrectedValue);
  }

  getDienstData(event: any) {
    this.selectedDienst = event?.code;
    this.selectedDienst === 'SONDER' ? this.setDeliveryTime = true : this.setDeliveryTime = false;
    this.diensttypId = event?.id;
  }

  sortedDienste(dienste): void {
    dienste.map((dienst: Dienst) => {
      switch (dienst.code) {
        case 'PLUS8':
          dienst.sortId = 1;
          break;
        case 'PLUS9':
          dienst.sortId = 2;
          break;
        case 'FRUEH':
          dienst.sortId = 3;
          break;
        case 'VORMITTAG':
          dienst.sortId = 4;
          break;
        case 'NORMAL':
          dienst.sortId = 5;
          break;
        case 'ABEND':
          dienst.sortId = 6;
          break;
        case 'SONDER':
          dienst.sortId = 7;
          break;
      }
    });

    this.dienste.sort((a, b) => a.sortId - b.sortId);
  }

  formatedDateString(event: Date): string {
    const month = (event.getMonth() + 1);
    const parsingDate = event.getDate() <= 9 ? '0' + event.getDate() : event.getDate();
    const parsingMonth = month <= 9 ? '0' + month : month;
    const date = parsingDate + '.' + parsingMonth + '.' + event.getFullYear() + ' ' + this.timeToDisplay + ':00';

    return date;
  }




  public checkChange (event) {
    let pointToComma = event.target.value.replace(/(\d),(?=\d)/g, '$1.');
    let inputAsInt = Number(pointToComma);
    if (inputAsInt >= 0 && inputAsInt < 25000) {
      this.displayError = false;
      this.isGewichtValid = true;
      this.cd.detectChanges();
      return this.shipmentInfoDetails.gesamtgewicht = inputAsInt.toString();
    } else {
      this.displayError = true;
      this.isGewichtValid = false;
      this.cd.detectChanges();
      return this.shipmentInfoDetails.gesamtgewicht;
    }
  }
}
